<template>
  <div id="app7">
      <Parallax1 />
  </div>
</template>

<script>
import Parallax1 from './components/Parallax1';

export default {
  name: 'AppParallax',
  components: {
    Parallax1,
  }
}
</script>
